import './FilterOptionRatingItem.scss';

import useTranslation from '@hooks/useTranslation';
import { createClsNameMap, mapModifiers } from '@utils';

import type { FilterOptionItemSettings } from '@/features/filter-product-list/filter/FilterOptionItem';
import {
  FilterOptionItem,
  useFilterOptionItem,
} from '@/features/filter-product-list/filter/FilterOptionItem';
import FilterOptionItemButton from '@/features/filter-product-list/filter/FilterOptionItem/Button';

export const clsNameMap = createClsNameMap({
  modifiers: ['selected', 'disabled'],
  elements: {
    presentation: createClsNameMap(),
    'icon-star': createClsNameMap({
      modifiers: ['active'],
    }),
  },
})('filter-option-rating-item');

export type FilterOptionRatingItemProps = {
  filterOptionId: string;
  value: string;
  adaLabel?: string;
  from: number;
  to: number;
  starColor: string;
  docCount?: number;
  settings: FilterOptionItemSettings;
  showExactRating?: boolean;
};

const starPresentationArray = Array(5).fill(null);

const FilterOptionRatingItem = ({
  filterOptionId,
  starColor,
  from,
  docCount,
  adaLabel,
  settings,
  showExactRating,
}: FilterOptionRatingItemProps) => {
  const { t } = useTranslation();

  const { isOptionItemSelected, handleOptionItemSelect, showFilterOptionCount } =
    useFilterOptionItem({
      value: from.toFixed(),
      filterOptionId,
    });

  const disabled = !docCount;

  return (
    <FilterOptionItem
      className={mapModifiers(clsNameMap, { selected: isOptionItemSelected, disabled })}
    >
      <FilterOptionItemButton
        as='button'
        isSelected={isOptionItemSelected}
        hasCheckbox={settings.selectType === 'multiple'}
        btnLabelledBy={adaLabel}
        docCount={docCount}
        showFilterOptionCount={showFilterOptionCount}
        label={
          <span role='presentation' className={clsNameMap.elm('presentation')}>
            {starPresentationArray.map((_, index) => (
              <i
                key={index}
                style={{ color: starColor }}
                className={mapModifiers(clsNameMap['icon-star'], {
                  active: index < from,
                })}
              ></i>
            ))}
            {showExactRating === false && t('ratingUp') + ' '}
          </span>
        }
        onClick={() => {
          if (!disabled) handleOptionItemSelect();
        }}
      />
    </FilterOptionItem>
  );
};

export default FilterOptionRatingItem;
